import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const CATEGORIES = [
  {
    name: "Graphic Tees",
    tag: "Drop 01",
    image: "/assets/mockup-4.jpg",
    testid: "category-box-tees",
  },
  {
    name: "Heavyweight Hoodies",
    tag: "Essential",
    image: "/assets/mockup-6.jpg",
    testid: "category-box-hoodies",
  },
  {
    name: "Caps & Accessories",
    tag: "Limited",
    image: "/assets/mockup-1.jpg",
    testid: "category-box-accessories",
  },
];

export const CategoryBoxes = () => {
  return (
    <section id="categories" data-testid="categories-section" className="bg-fog py-16 sm:py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="mb-12 flex flex-wrap items-end justify-between gap-4"
        >
          <div>
            <p className="mb-3 flex items-center gap-3 font-body text-xs font-medium uppercase tracking-[0.3em] text-tiger">
              <span className="h-px w-8 bg-tiger" />Shop By Category
            </p>
            <h2 className="font-heading text-2xl font-bold uppercase tracking-tight text-zinc-900 sm:text-3xl lg:text-4xl">
              Built For The Hunt
            </h2>
          </div>
          <a href="#shop" data-testid="categories-view-all-link" className="font-heading text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 transition-colors hover:text-tiger">
            View All Products →
          </a>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 sm:gap-8 md:grid-cols-3">
          {CATEGORIES.map((cat, i) => (
            <motion.a
              key={cat.name}
              href="#shop"
              data-testid={cat.testid}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.12 }}
              className="group relative block overflow-hidden border border-zinc-200 bg-white transition-all duration-300 hover:-translate-y-2 hover:border-tiger hover:shadow-[0_0_40px_rgba(255,85,0,0.25)]"
            >
              <div className="relative h-80 overflow-hidden sm:h-96">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/90 via-ink/20 to-transparent" />
                <span className="absolute left-4 top-4 bg-tiger px-3 py-1 font-heading text-[10px] font-bold uppercase tracking-widest text-black">
                  {cat.tag}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 flex items-center justify-between p-6">
                <h3 className="font-heading text-xl font-semibold uppercase text-white transition-colors group-hover:text-tiger sm:text-2xl">
                  {cat.name}
                </h3>
                <span className="flex h-10 w-10 items-center justify-center border border-white/40 text-white transition-all group-hover:border-tiger group-hover:bg-tiger group-hover:text-black">
                  <ArrowUpRight size={18} />
                </span>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};
